/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

/*eslint-disable*/

var VIDEO_MODE,
    display,
    width,
    height;

if ( window.parent.stbDisplayManager ) {
    module.exports = window.parent.stbDisplayManager;
} else {
    VIDEO_MODE = window.parent.gSTB.RDir('vmode');
    switch ( VIDEO_MODE ) {
        case '1080i':
        case '1080i60':
        case '1080p':
        case '1080p60':
            width = 1920;
            height = 1080;
            break;
    }
    display = {
        width: screen.width,
        height: screen.height
    };

    module.exports = {
        list: [display]
    }
}
